import React, {useEffect, useState} from "react";

const LayerView =  (props) => {
  const [boardLeft, setBoardLeft] = useState(document.body.clientWidth/2-150)

  useEffect(() => {
    const CheckStyle = () => {
      setBoardLeft(document.body.clientWidth/2-150)
    }
    window.addEventListener("resize", CheckStyle);
  }, [boardLeft])


  return (
    <div>
      {/* BACKGROUND */}
      <div
        style={{
          position: "absolute",
          left:
            props.left + boardLeft
            + (props.borderThickness * 300) / 500,
          top:
            props.top
            + (props.borderThickness * 300) / 500,
          width: props.width,
          height: props.height,
          backgroundColor: props.backgroundColor,
          //opacity: props.opacity / 100.0,
          transform: "rotate(" + props.rotateAngle + "deg)",
          zIndex: 1
        }}
      ></div>

      {/* Image */}
      {!props.ratio && (
        <img
          src={props.imageUrl}
          style={{
            position: "absolute",
            left: props.left + boardLeft
            + (props.borderThickness * 300) / 500,

            top: props.top
            + (props.borderThickness * 300) / 500 +
            ((100 - props.lineHeight) * props.fontSize) / 100,

            width: props.width,
            height: props.height,
            transform: "rotate(" + props.rotateAngle + "deg)",
            opacity: props.pictureOpacity/100.0,
            zIndex: 1,
          }}
        />
      )}
      {props.ratio && (
        <img
          src={props.imageUrl}
          style={{
            position: "absolute",
            left: props.left + boardLeft
            + (props.borderThickness * 300) / 500,

            top: props.top
            + (props.borderThickness * 300) / 500 +
            ((100 - props.lineHeight) * props.fontSize) / 100,

            width: props.width,
            transform: "rotate(" + props.rotateAngle + "deg)",
            opacity: props.pictureOpacity/100.0,
            zIndex: 1,
          }}
        />
      )}

      {/* BORDER */}
      <div
          style={{
            position: "absolute",
            left: props.left + boardLeft,
            top: props.top,
            width: props.width,
            height: props.height,
            transform: "rotate(" + props.rotateAngle + "deg)",
            //border: "1px solid #000000"
            border:
              (props.borderThickness * 300) / 500 +
              "px solid " +
              props.borderColor,
            //opacity: props.opacity / 100.0,
            zIndex: 1
          }}
        ></div>

      {/* TEXT */}
      <div
        style={{
          position: "absolute",
          left:
            props.left + boardLeft
            + (props.borderThickness * 300) / 500,
          top:
            props.top
            + (props.borderThickness * 300) / 500,
          width: props.width,
          height: props.height,
          overflow: 'hidden',
          color: props.textColor,
          transform: "rotate(" + props.rotateAngle + "deg)",

          textAlign: props.textAlign,
          fontFamily: props.font,
          fontSize:
            (300 * props.fontSize) / 500 + "px",
          fontWeight: props.fontWeight,
          fontStyle: props.fontStyle,
          fontFamily: props.font,
          textDecoration: props.textDecoration,
          lineHeight: props.lineHeight / 100 + "em",
          //lineHeight: (props.lineHeight * props.fontSize / 100) + 'px',            color: props.textColor,
          opacity: props.textOpacity / 100.0,

          zIndex: 1
        }}
      >{props.text}</div>

    </div>
  );
};

export default LayerView;
